import React from 'react';
import { useTranslation } from 'react-i18next';
import { Loader2 } from 'lucide-react';

const LOGO_URL = 'https://customer-assets-wrfwihn1.emergentagent.net/job_aac32766-5fa5-4a83-81c9-03bafeaebc9e/artifacts/bi1rz20k_loyerbook.png';

/**
 * Global loader with animated LoyerBook logo and "Please wait" label.
 * Variants:
 *  - full: fills the parent (used inside dashboard cards / tables)
 *  - overlay: fixed absolute overlay for modals / async pages
 *  - inline: small horizontal spinner + text (used in buttons)
 */
export function Loader({ variant = 'full', label, testid = 'lb-loader' }) {
  const { t } = useTranslation();
  const text = label || t('common.pleaseWait');

  if (variant === 'inline') {
    return (
      <span data-testid={testid} className="inline-flex items-center gap-2 text-sm text-slate-600">
        <Loader2 className="w-4 h-4 text-[#1677FF] lb-spin" />
        {text}
      </span>
    );
  }

  if (variant === 'overlay') {
    return (
      <div
        data-testid={testid}
        className="fixed inset-0 z-50 flex items-center justify-center bg-white/70 backdrop-blur-sm"
      >
        <LoaderCore text={text} />
      </div>
    );
  }

  // full (default) — occupies available space
  return (
    <div data-testid={testid} className="w-full py-16 flex items-center justify-center">
      <LoaderCore text={text} />
    </div>
  );
}

function LoaderCore({ text }) {
  return (
    <div className="flex flex-col items-center gap-4">
      <div className="relative">
        <div className="absolute inset-0 lb-logo-pulse" />
        <img src={LOGO_URL} alt="LoyerBook" className="relative w-16 h-16 lb-logo-anim" />
      </div>
      <div className="flex items-center gap-2 text-sm font-medium text-[#0D1B2A]">
        <Loader2 className="w-4 h-4 text-[#1677FF] lb-spin" />
        {text}
      </div>
    </div>
  );
}
